export const productColors: Record<string, string> = {
    '-1': "#ffffff",
    1: "#d6040e",
    2: "#ba261c",
    3: "#a84a57",
    4: "#e42502",
    5: "#f05e00",
    6: "#e0ba6e",
    7: "#9e7c56",
    8: "#d61a39",
    9: "#da792a",
    10: "#da9840",
    11: "#7c8417",
    12: "#c38c4a",
    13: "#ac7348",
    14: "#cb55ad",
    15: "#481c09",
    16: "#cb4e07",
    17: "#1c7c00",
    19: "#393d3e",
    20: "#c10e24",
    21: "#f29909",
    22: "#d47b66",
    23: "#9bb35d",
    24: "#cbc977",
    25: "#f9f4f7",
    26: "#3d8100",
    27: "#bb9878",
    28: "#407713",
    29: "#8135ac",
    30: "#a27e66",
    31: "#fce7bb",
    32: "#de5581",
    33: "#dadfe5",
    34: "#409c14",
    35: "#7d4c57",
    36: "#a5cd52",
    37: "#fff93c",
    38: "#4d6d46",
    40: "#e6b363",
    41: "#d53803",
    42: "#a9b746",
    43: "#412a7b",
    44: "#6a1825",
    45: "#679500",
    46: "#9ccf1c",
    47: "#de3810",
    48: "#567923",
    49: "#8fad5d",
    50: "#e5e6e2",
    51: "#ff6364",
    52: "#50750b",
    53: "#fa7609",
    54: "#f9df5c",
};

export const setBorderColor = (productId: number | undefined) => {
    return productId ? productColors[`${productId}`] : "#C2C2C2";
};
